<template>
    <div>
        <div :class="isMobile?'contBoxB':'contBox'">
           <div class="clearfix">
            <span class="fl mr5" :class="isMobile?'ml10':''">当前位置:</span>
            <el-breadcrumb class="fl" style="margin-top: 4px;font-size: 15px;" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>组织架构</el-breadcrumb-item>
            </el-breadcrumb>
           </div>
           <div :class="isMobile?'contentShowB':'contentShow'">
                <p class="contsTitle">{{info.Title}}</p>
                <div class="contSHow" v-html="info.Content"></div>
           </div>
        </div>
    </div>
</template>

<script>
    export default{
        data(){
            return{
                info:''
            }
        },
        methods:{
            //获取组织架构信息
            getInfo(){
                this.Request({
                    url: '/api/NewsData/GetNewsDataOne',
                    method: 'get',
                    data:{
                        cataCode:107
                    }
                }).then((data) => {
                   this.info = data.Data
                })
            }
        },
        mounted(){
            this.getInfo()
        }
    }
</script>
